// extracted by mini-css-extract-plugin
export var statItem = "_mk-1";
export var statsRow = "_mk-0";